import React, { ReactNode } from 'react';

interface Layout2x2Props {
  block1: ReactNode;
  block2?: ReactNode;
  block3?: ReactNode;
  block4?: ReactNode;
  className?: string;
  children?: ReactNode;
}

const Layout2x2 = ({ block1, block2, block3, block4, className, children }: Layout2x2Props): JSX.Element => {
  return (
    <div className={`container ${className ? className : ''}`}>
      {children && (
        <div className="row">
          <div className="col-span-1 xs:hidden md:col-span-1 md:block" />
          <div className="col-span-11 xs:col-span-9 sm:col-span-8 md:col-span-6 lg:col-span-5">{children}</div>
        </div>
      )}

      <div className="xs:space-y-64">
        {block1 && block2 && (
          <div className="row">
            <div className="col-span-4 xs:col-span-1 sm:col-span-3" />

            <div className="col-span-8 mb-32 xs:col-span-5 xs:mb-0 sm:col-span-4 md:col-span-3">{block1 && block1}</div>

            <div className="col-span-4 xs:col-span-1" />

            <div className="col-span-8 mb-32 xs:col-span-5 xs:mb-0 sm:col-span-4 md:col-span-3">{block2 && block2}</div>
          </div>
        )}

        {block3 && block4 && (
          <div className="row">
            <div className="col-span-4 xs:col-span-1 sm:col-span-3" />

            <div className="col-span-8 mb-32 xs:col-span-5 xs:mb-0 sm:col-span-4 md:col-span-3">{block3 && block3}</div>

            <div className="col-span-4 xs:col-span-1" />

            <div className="col-span-8 mb-32 xs:col-span-5 xs:mb-0 sm:col-span-4 md:col-span-3">{block4 && block4}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Layout2x2;
